<script>
import ModalBus from '@/eventBus'

export default {
  name: 'SuccessQuoteForm',

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-xl bg-white">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <span class="max-w-10/12 font-poppins text-xl font-medium lg:text-secondary">
        {{ $t('reminder.quoteReminderSuccess.title') }}
      </span>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <div class="p-5">
      <div class="flex w-full items-start rounded-xl border border-primary px-2 py-4">
        <svg
          class="mr-4 h-auto w-8"
          fill="none"
          height="34"
          viewBox="0 0 31 34"
          width="31"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M31 8.99111H24.9963L26.9976 6.98889C24.3167 4.30667 20.7674 2.83333 16.9915 2.83333C13.2156 2.83333 9.66626 4.30667 6.98538 6.98889C4.30451 9.67111 2.83191 13.2222 2.83191 17C2.83191 17.7933 2.19001 18.4356 1.39708 18.4356C0.604141 18.4356 0 17.7933 0 17C0 12.4667 1.77466 8.19778 4.98417 4.98667C8.19367 1.77556 12.4604 0 16.9915 0C21.5225 0 25.7893 1.77556 28.9988 4.98667L31 2.98444V8.99111Z"
            fill="#469752" />
          <path
            d="M16.9915 31.1666C17.7844 31.1666 18.4263 31.8088 18.4263 32.6022C18.4263 33.3955 17.7467 34 16.9915 34C16.1985 34 15.5566 33.3577 15.5566 32.5644C15.5566 31.7711 16.1985 31.1666 16.9915 31.1666Z"
            fill="#469752" />
          <path
            d="M22.9573 29.9955C23.7502 29.9955 24.3921 30.6377 24.3921 31.431C24.3921 32.2244 23.7502 32.8666 22.9573 32.8666C22.1644 32.8666 21.5225 32.2244 21.5225 31.431C21.5225 30.6377 22.1644 29.9955 22.9573 29.9955Z"
            fill="#469752" />
          <path
            d="M28.0169 26.5956C28.8098 26.5956 29.4517 27.2378 29.4517 28.0311C29.4517 28.8245 28.8098 29.4667 28.0169 29.4667C27.2239 29.4667 26.582 28.8245 26.582 28.0311C26.582 27.2378 27.2239 26.5956 28.0169 26.5956Z"
            fill="#469752" />
          <path
            d="M11.0257 29.9955C11.8186 29.9955 12.4605 30.6377 12.4605 31.431C12.4605 32.2244 11.8186 32.8666 11.0257 32.8666C10.2327 32.8666 9.59082 32.2244 9.59082 31.431C9.59082 30.6377 10.2327 29.9955 11.0257 29.9955Z"
            fill="#469752" />
          <path
            d="M5.96609 26.5956C6.75902 26.5956 7.40092 27.2378 7.40092 28.0311C7.40092 28.8245 6.75902 29.4667 5.96609 29.4667C5.17315 29.4667 4.53125 28.8245 4.53125 28.0311C4.53125 27.2378 5.21091 26.5956 5.96609 26.5956Z"
            fill="#469752" />
          <path
            d="M2.60573 21.5333C3.39867 21.5333 4.04057 22.1755 4.04057 22.9689C4.04057 23.7622 3.39867 24.4044 2.60573 24.4044C1.8128 24.4044 1.1709 23.7622 1.1709 22.9689C1.1709 22.1755 1.8128 21.5333 2.60573 21.5333Z"
            fill="#469752" />
          <path
            d="M25.4876 20.4001V20.7023C25.4876 21.949 24.9967 23.1578 24.1283 24.0267C23.1843 24.9712 21.9382 25.5001 20.6167 25.5001C19.7482 25.5001 18.8798 25.2734 18.1246 24.8201C14.3865 22.6667 11.328 19.6067 9.17575 15.9045C8.72265 15.149 8.49609 14.2801 8.49609 13.4112C8.49609 12.089 9.02472 10.8423 9.96869 9.89784C10.8371 9.02895 12.0454 8.53784 13.2915 8.53784H13.5935L15.2927 13.0712L13.5935 14.7334C15.1039 16.9623 17.0296 18.889 19.2574 20.4001L20.9565 18.7001L25.4876 20.4001Z"
            fill="#469752" />
        </svg>
        <p class="font-sans text-sm font-bold text-primary">{{ $t('reminder.quoteReminderSuccess.panel') }}</p>
      </div>
      <p class="mt-4 font-sans text-sm text-light">
        {{ $t('reminder.quoteReminderSuccess.description', { name: $data.appName, country: $data.appCountry }) }}
      </p>
      <div class="mt-4 flex w-full flex-col">
        <a
          class="btn mb-4 w-full"
          href="/"
          >{{ $t('buttons.backToIndex') }}</a
        >
      </div>
    </div>
  </div>
</template>
